export default __webpack_public_path__ + "static/media/caret-right-gray.4e8b0ce3.svg";